import React from 'react'

import { LoadingIndicator } from '../LoadingIndicator/LoadingIndicator'

import { Circle } from './Circle'

interface ItemProps {
  label: React.ReactNode
  value: string
}

interface Props {
  topItem?: ItemProps
  leftItem?: ItemProps
  rightItem?: ItemProps
  progressLeft?: number

  loading?: boolean
}

export const ProgressCircle: React.FC<Props> = ({
  topItem,
  leftItem,
  rightItem,
  progressLeft = 0,

  loading
}: Props) => {
  return (
    <>
      <div className="progresscircle-wrapper">
        <div className="progresscircle-wings">
          {leftItem && (
            <>
              {leftItem.value}
              <span>{leftItem.label}</span>
            </>
          )}
        </div>
        <div className="progresscircle-main">
          <div className="progresscircle-main-inner">
            {topItem && (
              <>
                {topItem.value}
                <span>{topItem.label}</span>
              </>
            )}
          </div>
          <Circle radius={70} stroke={5} percent={progressLeft} />
          {loading && (
            <div style={{ position: 'absolute' }}>
              <LoadingIndicator color="white" />
            </div>
          )}
        </div>
        <div className="progresscircle-wings">
          {rightItem && (
            <>
              {rightItem.value}
              <span>{rightItem.label}</span>
            </>
          )}
        </div>
      </div>
    </>
  )
}
